<div class="container mt-card pt-4">
    <div class="card mt-3">
        <div class="card-header">
            <h3>
                Update Examination Penalty
            </h3>
        </div>
        <div class="card-body">
            <form #examForm (ngSubmit)="saveExam()">
                <div class="d-flex justify-content-center mb-3 text-danger" *ngIf="modelError">
                    <p>{{modelError}}</p>
                </div>

                <div class="row d-flex justify-content-center mb-3">
                    <div class="col-md-5  mr-5">
                        <div class="form-group">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input mr-1"
                                    [(ngModel)]="examPenalty.detectFocusLoss" [ngModelOptions]="{ standalone: true }">
                                <label class="custom-control-label" for="customCheck1">
                                    Detect FocusLoss
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-5"></div>
                </div>

                <div>
                    <div class="row d-flex justify-content-center mb-3">
                        <div class="col-md-5">
                            <div class="form-group">
                                <label>Loss of Focus Action</label>
                                <ng-select class="form-select" [(ngModel)]="examPenalty.focusLossAction"
                                    [disabled]="!examPenalty.detectFocusLoss" [ngModelOptions]="{ standalone: true }">
                                    <ng-option selected value="" disabled>Select Loss of Focus Action</ng-option>
                                    <ng-option value="NotSet">None</ng-option>
                                    <ng-option value="Disqualify">Disqualify</ng-option>
                                    <ng-option value="RestartExam">Restart Exam</ng-option>
                                    <ng-option value="EndExam">End Exam</ng-option>
                                    <ng-option value="ReduceTIme">Reduce Exam Time</ng-option>
                                </ng-select>
                            </div>
                        </div>
                    </div>
                    <div class="row d-flex justify-content-center mb-3">
                        <div class="col-md-5 mr-5">
                            <div class="form-group">
                                <label>Permissible Duration Of Focus Loss (Seconds)</label>
                                <input type="number" min="0" class="form-control"
                                    [disabled]="!examPenalty.detectFocusLoss"
                                    placeholder="Permissible Duration Of Focus Loss (Seconds)"
                                    [(ngModel)]="examPenalty.permissibleDurationOfLoss"
                                    [ngModelOptions]="{ standalone: true }">
                            </div>
                        </div>
                        <div class="col-md-5">
                            <div class="form-group">
                                <label>No Of Times Allowed For Focus Loss</label>
                                <input type="number" min="0" class="form-control"
                                    [disabled]="!examPenalty.detectFocusLoss"
                                    placeholder="No Of Times Allowed For Focus Loss"
                                    [(ngModel)]="examPenalty.maxAllowedFocusLossCount"
                                    [ngModelOptions]="{ standalone: true }">
                            </div>
                        </div>
                    </div>
                    <div class="row d-flex justify-content-center mb-3">
                        <div class="col-md-5 mr-5">
                            <div class="form-group">
                                <label>Loss of Focus Reduce Time Action Duration (Minutes)</label>
                                <input type="number" min="0" class="form-control"
                                    [disabled]="!examPenalty.detectFocusLoss"
                                    placeholder="Permissible Duration Of Focus Loss (Seconds)"
                                    [(ngModel)]="examPenalty.focussLossTimePenalty"
                                    [ngModelOptions]="{ standalone: true }">
                            </div>
                        </div>
                        <div class="col-md-5">
                            <div class="form-group">
                                <label>Loss of Focus Restart Action Limit</label>
                                <input type="number" min="0" class="form-control"
                                    [disabled]="!examPenalty.detectFocusLoss"
                                    placeholder="No Of Times Allowed For Focus Loss"
                                    [(ngModel)]="examPenalty.focussLossRestartActionLimit"
                                    [ngModelOptions]="{ standalone: true }">
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row d-flex justify-content-center mt-4">
                    <button type="submit" class="btn btn-primary btn-md btn-block col-md-8 text-center">
                        Update Examination</button>
                </div>
            </form>
        </div>
    </div>
</div>